<div class="flex flex-col">
  <form [formGroup]="inputForm">
    <div class="flex flex-row justify-start items-center">
      <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
        <mat-label>Account Name</mat-label>
        <input matInput formControlName="accountName"
               particleAnalytics
               analyticsCategory="data-survey"
               analyticsAction="create-custom-form">
      </mat-form-field>
    </div>
    <div class="flex flex-row justify-start items-center">
      <mat-form-field appearance="outline" class="full-grow-no-shrink-no-basis">
        <mat-label>Description</mat-label>
        <textarea matInput type="text" formControlName="description"
                  rows="5">
              </textarea>
      </mat-form-field>
    </div>
  </form>
</div>


